import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BaseLayout from '../../layouts/BaseLayout';
import TaskFilters from './components/TaskFilters';
import TaskList from './components/TaskList';
import TaskModal from './components/TaskModal';
import { useApiHandler } from '../../utils/apiHandler';

function TaskPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiHandler = useApiHandler();

  useEffect(() => {
    const fetchTasks = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiHandler.get('https://emsbackend.vigilantvisionsystem.com/ec2/api/v1/employee/task-details', {
          params: { status: filterStatus }, // Pass the filter status as a query parameter
        });
        if (response.data.success) {
          console.log(response.data.data)
          setTasks(response.data.data);
        } else {
          setTasks([]);
        }
      } catch (err) {
        setError('Failed to fetch tasks. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [filterStatus]); // Refetch tasks whenever filterStatus changes

  const handleTaskClick = (task) => {
    setSelectedTask(task);
    setIsModalOpen(true);
  };

  return (
    <BaseLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">My Tasks</h1>
        </div>

        <TaskFilters
          currentFilter={filterStatus}
          onFilterChange={setFilterStatus}
        />

        {loading ? (
          <div className="text-center text-gray-500">Loading tasks...</div>
        ) : error ? (
          <div className="text-center text-red-500">{error}</div>
        ) : (
          <TaskList
            tasks={tasks}
            onTaskClick={handleTaskClick}
          />
        )}

        {isModalOpen && selectedTask && (
          <TaskModal
            task={selectedTask}
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              setSelectedTask(null);
            }}
          />
        )}
      </div>
    </BaseLayout>
  );
}

export default TaskPage;
